export default __webpack_public_path__ + "static/media/O-130.9222b788.png";